module.exports = __webpack_public_path__ + "img/pintu_down_code.2ee85c0a.png";